import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import webServices from '../../services/webServices';

const FeedbackModal = ({ show, handleClose }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setRating(0);
    setFeedback('');
  }, [show]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!rating || feedback.trim() === "") {
      setError("Please provide both feedback and rating.");
      return;
    }

    setError("");

    await webServices.submitFeedback({ rating, feedback })

    handleClose();
  };

  return (
    <Modal className="feedback_modal" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="w-100 text-center text-purple fw-bold">
          We’re excited to hear from you!
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit}>
          {/* Feedback Input */}
          <div className="mb-3">
            <textarea
              className="form-control rounded-3"
              placeholder="Let us know what we are doing great and we can do to enhance your experience..."
              rows="3"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              required
            />
          </div>

          {/* Rating */}
          <div className="rating mb-3">
            <p className="mb-1">How would you rate your experience?</p>
            {[...Array(5)].map((star, index) => {
              // eslint-disable-next-line no-param-reassign
              index += 1;
              return (
                <button
                  type="button"
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  className={`btn p-0 mx-1 fs-3 ${index <= (hover || rating)
                    ? "text-warning"
                    : "text-muted"
                    }`}
                  onClick={() => setRating(index)}
                  onMouseEnter={() => setHover(index)}
                  onMouseLeave={() => setHover(rating)}
                >
                  <i className="fa fa-star" />
                </button>
              );
            })}
          </div>

          {/* Error Message */}
          {error && (
            <div className="text-danger text-center mb-2">
              {error}
            </div>
          )}

          {/* Submit */}
          <div className="d-grid">
            <Button type="submit" className="rounded-pill fw-bold theme-btn">
              Submit feedback
            </Button>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer className="border-0 justify-content-center footer-feedback">
        <small>
          If you’d like immediate assistance contact us through{" "}
          <a href="mailto:support@lovrican.com" className="text-decoration-none">
            support@lovrican.com
          </a>
        </small>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackModal;
